import React from 'react';

const MarkupOption = ({ title, id, name, value, valueCheck, onChange, disabled }) => {
  const handleChange = (event) => {
    onChange && onChange(event.target.value, event);
  };
  return (
    <>
      <input
        id={ id }
        name={ name }
        type="radio"
        value={ value }
        checked={ valueCheck === value }
        onChange={ handleChange }
        disabled={ disabled }
      />
      <label htmlFor={ id }>{ title }</label>
    </>
  );
};

export default MarkupOption;
